import React from 'react';
import styled from 'styled-components';

import CloseIcon from '~/assets/close.svg';

const CloseContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  fill: ${(props) => props.theme.colors.blue};
  position: absolute;
  top: 8px;
  right: 8px;
`;

const CloseIconStyled = styled(CloseIcon)`
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

function Closer({ setInfoboxContent }) {
  return (
    <CloseContainer>
      <CloseIconStyled onClick={() => setInfoboxContent(false)} />
    </CloseContainer>
  );
}

export default Closer;
